import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'vfs-list-view-new',
  templateUrl: './list-view-new.component.html',
  styleUrls: ['./list-view-new.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ListViewNewComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
